<div
  class="h-full audit-logs"
  cdkOverlayOrigin
>
  <flx-resources-page
    [pageTitle]="title()"
    class="h-full"
    searchInputPlaceholder="Search by user name"
    data-testId="audit-table-modal"
  >
    <ng-container ngProjectAs="[flxResourcesPageBody]">
      <app-audit-logs-table
        [initialQuery]="initialQuery()"
        [tableColumnsDef]="auditTableDef()"
        class="h-full"
      ></app-audit-logs-table>
    </ng-container>
  </flx-resources-page>
</div>
